import React from 'react';
import { Calendar, Package, Clock, Users, AlertCircle } from 'lucide-react';

// ✅ NOTA: En la v3.1 este componente consumirá datos del 'eventosGlobal' del GlobalContext
const CalendarioActividades = () => {
  // --- DATOS DE EVENTOS (Próximamente vendrán del GlobalContext o API) ---
  const eventos = [
    { 
      id: 1, 
      titulo: 'Festival de Primavera', 
      fecha: 'Domingo 22 de Marzo', 
      hora: '10:30 AM',
      grupo: 'Párvulos (3-5 años)',
      material: 'Playera blanca cómoda, botellita de agua marcada con su nombre y un girasol de fomi o papel.', 
      urgente: true
    },
    { 
      id: 2, 
      titulo: 'Día de Superhéroes', 
      fecha: 'Domingo 5 de Abril', 
      hora: '11:00 AM',
      grupo: 'Todos los grupos',
      material: 'Venir disfrazado de su superhéroe favorito (opcional) o traer una capa hecha en casa.', 
      urgente: false
    }
  ];

  return (
    <div className="space-y-8 animate-in fade-in slide-in-from-bottom-4 duration-500 max-w-2xl mx-auto pb-10">
      
      {/* TÍTULO DE LA SECCIÓN */}
      <div className="text-center space-y-2">
        <h2 className="text-3xl font-black text-slate-900 italic tracking-tight uppercase">Próximos Eventos</h2>
        <p className="text-xs font-black text-indigo-500 uppercase tracking-[0.2em] italic">Actividades y materiales especiales</p>
      </div>

      {/* LISTA DE EVENTOS */}
      <div className="space-y-6">
        {eventos.map((evento) => (
          <div 
            key={evento.id} 
            className="bg-white rounded-[3rem] shadow-sm border-2 border-slate-100 overflow-hidden hover:shadow-xl hover:border-indigo-100 transition-all duration-300"
          >
            {/* ENCABEZADO DE LA TARJETA */}
            <div className={`px-8 py-4 flex items-center justify-between border-b-2 ${
              evento.urgente ? 'bg-rose-50 border-rose-100' : 'bg-slate-50 border-slate-100'
            }`}>
              <div className="flex items-center gap-3">
                <Calendar size={20} className={evento.urgente ? 'text-rose-500' : 'text-slate-400'} />
                <span className={`text-[11px] font-black uppercase tracking-widest ${
                  evento.urgente ? 'text-rose-600' : 'text-slate-500'
                }`}>
                  {evento.fecha}
                </span>
              </div>
              <div className="flex items-center gap-1.5 text-slate-400 bg-white px-3 py-1 rounded-full border border-slate-200">
                <Clock size={14} />
                <span className="text-[10px] font-black tracking-tighter uppercase">{evento.hora}</span>
              </div>
            </div>

            {/* CUERPO DE LA TARJETA */}
            <div className="p-8 space-y-6 text-left">
              <div>
                <h3 className="text-2xl font-black text-slate-900 leading-tight mb-2 italic tracking-tight uppercase">
                  {evento.titulo}
                </h3>
                <div className="inline-flex items-center gap-2 bg-indigo-50 text-indigo-600 px-4 py-1.5 rounded-xl">
                  <Users size={16} />
                  <span className="text-[10px] font-black uppercase tracking-widest">
                    Grupo: <span className="text-indigo-800">{evento.grupo}</span>
                  </span>
                </div>
              </div>

              {/* CAJA DE MATERIAL SOLICITADO */}
              <div className="bg-amber-50 rounded-[2rem] p-6 border-2 border-amber-100/50 flex gap-5 items-start relative overflow-hidden">
                <Package className="absolute -right-6 -bottom-6 opacity-10 text-amber-600" size={100} strokeWidth={1} />
                
                <div className="w-12 h-12 rounded-2xl bg-amber-100 flex items-center justify-center text-amber-600 shrink-0 relative z-10 shadow-sm">
                  <Package size={24} />
                </div>
                
                <div className="relative z-10">
                  <h4 className="text-[10px] font-black uppercase tracking-[0.2em] text-amber-600 mb-2 flex items-center gap-1.5 italic">
                    <AlertCircle size={14} /> Material Requerido
                  </h4>
                  <p className="text-sm font-bold text-slate-800 leading-relaxed italic">
                    "{evento.material}"
                  </p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* PIE DE PÁGINA INFORMATIVO */}
      <div className="bg-[#0A2440] p-8 rounded-[3rem] text-center shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-indigo-500 via-amber-500 to-rose-500" />
        <p className="text-xs text-slate-300 font-bold leading-relaxed relative z-10 uppercase tracking-widest italic">
          Tu apoyo con los materiales nos permite <br />
          <span className="text-amber-400">crear momentos inolvidables</span> para ellos.
        </p>
      </div>

    </div>
  );
};

export default CalendarioActividades;